import { ReactComponent as FACEBOOK } from '../../assets/logos/facebook-f_1.svg'
import { ReactComponent as GITHUB } from '../../assets/logos/github_10.svg'
import { ReactComponent as LINKDIN } from '../../assets/logos/linkedin_6.svg'
import { ReactComponent as MAIL } from '../../assets/logos/mail-outline_1.svg'

export const socialsArr = [
  {
    href: 'https://www.linkedin.com/in/stephan-benchemoul-38879320b/',
    src: LINKDIN,
    alt: 'linkdin'
  },
  {
    href: 'https://github.com/stephanbazbaz',
    src: GITHUB,
    alt: 'github'
  },
  {
    href: 'https://www.facebook.com/ethan.hearing.10/',
    src: FACEBOOK,
    alt: 'facebook'
  },
  {
    href: 'mailto:stephanbncml@gmail.com',
    src: MAIL,
    alt: 'email'
  },
]